import { AddonDataType } from "../../interfaces/addons/Addon.type";
import useAppStore from "../../store/AppStore";
import AddonCard from "./desktop/AddonCard";
import AddonCardMobile from "./mobile/AddonCardMobile";

export default function AddonCardContainer({ items }: { items: AddonDataType[] }) {
  const { isDeviceMobile } = useAppStore();
  const item = items[0];

  return (
    <>
      {isDeviceMobile ? (
        <AddonCardMobile item={item} />
      ) : (
        <AddonCard item={item} />
      )}
    </>
  );
}
